"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var multiSelect_1 = require("../lib/multiSelect");
var SettingRow = function (props) {
    var inputElement = null;
    var name = props.setting.name;
    var settingId = "setting_" + name;
    switch (props.setting.type) {
        case 'text':
            inputElement = (React.createElement("input", { type: "text", id: settingId, name: name, value: props.setting.value, onChange: props.change, className: "form-control" }));
            break;
        case 'checkbox':
            inputElement = (React.createElement("input", { className: "Settings--checkbox", type: "checkbox", id: settingId, name: name, checked: props.setting.value, onChange: props.change }));
            break;
        case 'select':
            inputElement = (React.createElement("select", { id: settingId, name: name, value: props.setting.value, onChange: props.change, className: "form-control" }, props.setting.options.map(function (option) { return React.createElement("option", { value: option.value }, option.display_name); })));
            break;
        case 'multiselect':
            inputElement = (React.createElement(multiSelect_1.Multiselect, { id: settingId, name: name, choices: props.setting.options, value: props.setting.value, onChangeEvent: props.change, classes: "gm--fullwidth" }));
            break;
        default:
            console.error("Wrong type: ", props.setting.type);
    }
    return (React.createElement("div", { className: "form-group row" },
        React.createElement("label", { htmlFor: settingId, className: "col-6 col-form-label" }, props.setting.display),
        React.createElement("div", { className: "col-6 text-right" }, inputElement)));
};
exports.default = SettingRow;
